module.exports = "/_next/static/images/EmpowerMarketers-f441f3c5f167faca9439caf41fcc3375.webp";